import * as Yup from 'yup';
import { PasswordRegex } from '../../utils/helper';

export const CreatePasswordFormSchema = Yup.object().shape({
  createPassword: Yup.string()
    .min(8, 'Should be minimum 8 characters long')
    .matches(
      PasswordRegex,
      `At least one character
      At least one number
      At least one special character`,
    ),
  confirmPassword: Yup.string().oneOf([Yup.ref('createPassword'), null], 'Passwords must match'),
});
